import http from '@/utils/request'
import defaultSettings from '@/settings'

// 直接通过覆盖的方式

/**
   * 管理员分页查询
   * @param {查询条件} data
   */
export function getManagerListWithPager(data) {
  return http.request({
    url: 'Manager/FindWithPagerSearchAsync',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 新增或修改保存管理员
   * @param data
   */
export function saveManager(data, url) {
  return http.request({
    url: url,
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 获取管理员详情
   * @param {Id} 管理员Id
   */
export function getManagerDetail(id) {
  return http({
    url: 'Manager/GetById',
    method: 'get',
    params: { id: id },
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 获取管理员详情
   * @param {userName} 管理员账号
   */
export function getByManagerName(userName) {
  return http({
    url: 'Manager/GetByUserName',
    method: 'get',
    params: { userName: userName },
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 批量设置启用状态
   * @param {id集合} ids
   */
export function setManagerEnable(data) {
  return http({
    url: 'Manager/SetEnabledMarkBatchAsync',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 批量设为删除
   * @param {id集合} ids
   */
export function deleteSoftManager(data) {
  return http({
    url: 'Manager/DeleteSoftBatchAsync',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 批量删除
   * @param {id集合} ids
   */
export function deleteManager(data) {
  return http({
    url: 'Manager/DeleteBatchAsync',
    method: 'delete',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 重置密码
   * @param {userId:管理员id} data
   */
export function resetPassword(data) {
  return http({
    url: 'Manager/ResetPassword',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 修改密码
   * @param {password:新密码,password2:重复新密码} data
   */
export function modifyPassword(data) {
  return http({
    url: 'Manager/ModifyPassword',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 注册新管理员
   * @param data
   */
export function registerManager(data, url) {
  return http.request({
    url: 'Manager/Register',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 保存管理员主题配置
   * @param data
   */
export function saveThemeConfig(data) {
  return http.request({
    url: 'Manager/SaveUserTheme',
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}

/**
   * 新增或修改保存管理员
   * @param data
   */
export function saveExtend(data, url) {
  return http.request({
    url: url,
    method: 'post',
    data: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}
/**
   * 获取管理员详情
   * @param {Id} 管理员Id
   */
export function getExtendDetail(id) {
  return http({
    url: 'ManagerExtend/GetByManagerId',
    method: 'get',
    params: { managerId: id },
    baseURL: defaultSettings.apiSecurityUrl
  })
}



/**
   * 修改操作密码
   * @param {oldpassword:登录密码,password:操作密码} data
   */
export function modifyOperatePwd(data) {
  return http({
    url: 'Manager/ModifyOperatePwd',
    method: 'post',
    params: data,
    baseURL: defaultSettings.apiSecurityUrl
  })
}